import React, { useState } from 'react';

import moment from 'moment';

import { Report } from '~/components';
import { DateTime, Autocomplete, Input, RadioGroup } from '~/components/Form';
import { t } from '~/helpers';

function ReldiferencaEncerrante() {
  const [open, setOpen] = useState(true);
  const [posto, setPosto] = useState(0);

  const [valuePosto, setValuePosto] = React.useState(0);
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const [valueBico, setValueBico] = React.useState(0);
  const [inputValueBico, setInputValueBico] = React.useState('');

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });
  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  function handleSerializeForm(params) {
    const idPosto = valuePosto === 0 ? '' : valuePosto;
    const idBico = valueBico === 0 ? '' : valueBico;

    return {
      ...params,
      idposto: idPosto,
      idbico: idBico,
    };
  }

  async function handleCarregaBicos(value) {
    console.log(value);
    // await reference.current.setFieldValue('automaticobico', value);
    // await setYesOrNo(value);
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.diferencaencerrante')}
      relatorio="diferencaencerrante"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
      }}
    >
      {/* <span>POSTO</span>
      <div>{`valuePosto: ${valuePosto !== null ? `'${valuePosto}'` : 'null'}`}</div>
      <div>{`inputValuePosto: '${inputValuePosto}'`}</div>

      <span>BICO</span>
      <div>{`valueBico: ${valueBico !== null ? `'${valueBico}'` : 'null'}`}</div>
      <div>{`inputValueBico: '${inputValueBico}'`}</div> */}

      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ seconds: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ seconds: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <Autocomplete
        name="idposto"
        label="nomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.menu.configuracao.posto')}
        // first={[{ nomeposto: 'Todos', idposto: '' }]}
        value={valuePosto}
        inputValue={inputValuePosto}
        onChange={(event, newValue) => {
          setValuePosto(newValue);
        }}
        onInputChange={(event, newInputValuePosto) => {
          setInputValuePosto(newInputValuePosto);
        }}
        defaultValue=""
        hiddens={[{ name: 'nomeposto' }]}
        // getValue={({ idposto }) => setPosto(Number(idposto))}
        getValue={(value) => {
          setValueBico(0);
          setInputValueBico('');
          if (value.idposto !== null) {
            setPosto(Number(value.idposto));
            setValuePosto(Number(value.idposto));
          } else {
            setPosto(0);
            setValuePosto(0);
          }
          // ({ idposto }) => setPosto(Number(idposto));
        }}
      />

      <Autocomplete
        name="idbico"
        label="bicoprodutobico"
        url="bicos"
        unique="idbico"
        title={t('s.menu.configuracao.bico')}
        // first={[{ idbico: 'Todos', value: '' }]}
        value={valueBico}
        inputValue={inputValueBico}
        onChange={(event, newValue) => {
          setValueBico(newValue);
        }}
        onInputChange={(event, newInputValueBico) => {
          setInputValueBico(newInputValueBico);
        }}
        getValue={(value) => {
          setValueBico(value.idbico);
        }}
        disabled={posto === 0}
        params={{
          wherefield: 'idposto',
          valuewherefield: posto,
          typewherefield: 'EQUALS',
          fieldlist: 'idbico, idproduto, bicoprodutobico',
        }}
        // getValue={({ idproduto }) => setProduto(idproduto)}
      />

      <Input
        type="number"
        name="difencerrante"
        label={t('s.relatorio.diferencaencerrante.difencerrante')}
        min="0"
        step="0.01"
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default ReldiferencaEncerrante;
